import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IWorkspaceIdEntities, IWorkspaceState} from "../reducers/workspace.reducer";
import {WorkspaceClient} from "../../user-managment/workspace-client";
import {WorkspaceInvitation} from "../../user-managment/workspace-invitation";
import {Workspace} from "../../user-managment/workspace";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWorkspaceState = createSelector(getDbStoreState,
  (dbStoreState: DbStoreState) => dbStoreState.workspace
);

export const getWorkspaceLoaded = createSelector(getWorkspaceState,
  (state: IWorkspaceState): boolean =>
    state.loaded
);

export const getWorkspaceIdEntities = createSelector(getWorkspaceState,
  (state: IWorkspaceState): IWorkspaceIdEntities => {
    return {
      ownerWorkspaceId: state?.workspaceIdEntities?.ownerWorkspaceId,
      currentWorkspaceId: state?.workspaceIdEntities?.currentWorkspaceId,
      currentWorkspaceRoleId: state?.workspaceIdEntities?.currentWorkspaceRoleId,
      globalEventDispatcherService: state?.workspaceIdEntities?.globalEventDispatcherService
    };
  }
);
export const getOwnerWorkspaceId = createSelector(getWorkspaceState,
  (state: IWorkspaceState): number =>
    state.workspaceIdEntities.ownerWorkspaceId
);

export const getCurrentWorkspaceId = createSelector(getWorkspaceState,
  (state: IWorkspaceState): number =>
    state.workspaceIdEntities.currentWorkspaceId
);

export const getWorkspaceClients = createSelector(getWorkspaceState,
  (state: IWorkspaceState): WorkspaceClient[] =>
    state.workspaceClients
);

export const getWorkspaceInvitations = createSelector(getWorkspaceState,
  (state: IWorkspaceState): WorkspaceInvitation[] =>
    state.workspaceInvitations
);

export const getWorkspaceAllClients = createSelector(getWorkspaceState,
  (state: IWorkspaceState): any[] =>
    [...state.workspaceInvitations, ...state.workspaceClients]
);

export const getBillingInfo = createSelector(getWorkspaceState,
  (state: IWorkspaceState) =>
    state && state.billingInfo && state.billingInfo ? state.billingInfo.billingInfo : null
);

export const getBillingInfoLoaded = createSelector(getWorkspaceState,
  (state: IWorkspaceState) =>
    state && state.billingInfo && state.billingInfo.loaded
);

export const getWorkspaces = createSelector(getWorkspaceState,
  (state: IWorkspaceState): Workspace[] =>
    state && state.workspaces
);

export const getOwnerWorkspace = createSelector(getWorkspaceState,
  (state: IWorkspaceState): Workspace =>
    state && state.workspaces && state.workspaces.find(workspace => workspace.workspaceId === state.workspaceIdEntities.ownerWorkspaceId)
);

export const getCurrentWorkspace = createSelector(getWorkspaceState,
  (state: IWorkspaceState): Workspace =>
    state && state.workspaces && state.workspaces.find(workspace => workspace.workspaceId === state.workspaceIdEntities.currentWorkspaceId)
);
